import axios from "axios";
import {authtoken} from '@/values/private';

export default {
  namespaced: true,
  state: {
    companies: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    companiesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_COMPANIES(state, payload) {
      state.companies = payload;
      state.isReceiving = false;
    },
    RECEIVING_COMPANIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_COMPANY(state, payload) {
      state = Object.assign(state, {
        companies: [...state.companies, payload],
        isReceiving: false,
      })
    },
    RECEIVING_COMPANY(state) {
      state.isReceiving = true;
    },
    UPDATED_COMPANY(state, payload) {
      let index = state.companies.findIndex(company => company._id === payload._id);
      state = Object.assign(state, {
        companies: state.companies.map((company, i) => {
          if (i === index) {
            return Object.assign({}, company, payload);
          }
          return company;
        }),
        isUpdating: false,
        companiesMessage: 'Companies has been updating!',
      })
    },
    UPDATING_COMPANY(state) {
      state.isUpdating = true;
    },
    DELETED_COMPANY(state, payload) {
      let indexToDelete = state.companies.findIndex(company => company._id === payload._id);
      let companies = [...state.companies];
      companies.splice(indexToDelete, 1);
      state = Object.assign(state, {
        companies: [...companies],
        isDeleting: false,
        idToDelete: null,
        companiesMessage: 'Company has been Deleted!',
      });
    },
    DELETING_COMPANY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getCompaniesRequest({dispatch}) {
      dispatch("receivingCompanies");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/companies';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveCompanies", res.data);
      })
    },
    async getCompaniesByTokenRequest({dispatch}) {
      dispatch("receivingCompanies");
      let url = 'https://api.tradexc.com:3000/get/companies/token';
      let headers = {'Content-Type': 'application/json','authtoken': authtoken};
      let response = await axios({method: "GET", url: url, headers: headers})
      dispatch("receiveCompanies", response.data);
      return response.data;
    },
    updateCompanyRequest({dispatch}, payload) {
      dispatch("updatingCompany");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/company/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateCompany", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateCompanyImageRequest({dispatch}, payload) {
      dispatch("updatingCompany");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.tradexc.com:3000/update/company/image/' + id;
      let data = new FormData();
      data.append('image', payload.companyimage, payload.imagename); 
      delete payload['companyimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateCompany", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateCompanyOptionsRequest({dispatch}, payload) {
      dispatch("updatingCompany");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/company/options/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updateCompany", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateCompanySettingRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/companysetting/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertCompanyRequest({dispatch}, payload) {
      dispatch("receivingCompanies");
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.tradexc.com:3000/insert/company';
      let data = payload;
      await axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveCompany", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertCompanySettingRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/companysetting/' + payload.id;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    deleteCompanyRequest({dispatch}, payload) {
      dispatch("deletingCompany", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/company/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteCompany", {_id: payload._id});
      })
    },
    async deleteCompanySettingRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/companysetting/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveCompanies({commit}, payload) {
      commit("RECEIVED_COMPANIES", payload)
    },
    receivingCompanies({commit}) {
      commit("RECEIVING_COMPANIES")
    },
    receiveCompany({commit}, payload) {
      commit("RECEIVED_COMPANY", payload)
    },
    receivingCompany({commit}) {
      commit("RECEIVING_COMPANY")
    },
    updateCompany({commit}, payload) {
      commit("UPDATED_COMPANY", payload)
    },
    updatingCompany({commit}) {
      commit("UPDATING_COMPANY")
    },
    deleteCompany({commit}, payload) {
      commit("DELETED_COMPANY", payload)
    },
    deletingCompany({commit}, payload) {
      commit("DELETING_COMPANY", payload)
    }
  },
};
